import { render, staticRenderFns } from "./class.vue?vue&type=template&id=251722f8&"
import script from "./class.vue?vue&type=script&lang=js&"
export * from "./class.vue?vue&type=script&lang=js&"
import style0 from "./class.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports